module.exports = __webpack_public_path__ + "img/28_31.25abe6a6.png";